import React from "react"

function IconBuilding({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="building"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-building"
      {...props}
    >
      <path
        d="M11.976 1.428c.326 0 .595.237.646.548l.009.107V4.55l1.031.001a1.2 1.2 0 0 1 1.193 1.07l.007.13V7.23h.585a1.2 1.2 0 0 1 1.193 1.069l.007.13v11.742h.685a.655.655 0 0 1 .106 1.301l-.106.009H6.62a.655.655 0 0 1-.106-1.3l.106-.01h.684V8.43a1.2 1.2 0 0 1 1.07-1.193l.13-.007h.585V5.752a1.2 1.2 0 0 1 1.07-1.193l.13-.007h1.032v-2.47c0-.36.293-.654.654-.654zm3.362 7.11H8.614v11.633l2.022-.001.001-1.922c0-.301.245-.546.546-.546h1.587c.3 0 .545.245.545.546v1.922h2.023V8.54zm-1.577 6.32a.655.655 0 0 1 .106 1.3l-.106.008h-3.57a.655.655 0 0 1-.106-1.3l.106-.009h3.57zm0-2.51a.655.655 0 0 1 .106 1.3l-.106.01h-3.57a.655.655 0 0 1-.106-1.301l.106-.009h3.57zm0-2.509a.655.655 0 0 1 .106 1.3l-.106.01h-3.57a.655.655 0 0 1-.106-1.301l.106-.009h3.57zm-.209-3.979H10.4v1.37h3.153V5.86z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconBuilding
